import { styled } from "@mui/material/styles";

const StyledWrapper = styled('div')`
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  
  .ProductDetailHeader__container {
    height: 50px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .ProductDetailHeader__icon-btn {
    width: 40px;
    height: 40px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.1);

    svg{
      path{
        stroke: #fff;
      }
    }
  }
`;

export {
  StyledWrapper
};
